import SubPage from "../components/SubPage";

export default function Services() {
  return (
    <SubPage tKey="ds.page_services" image="/img/couple-tablet.jpg"
      sections={[
        { title: "ds.page_services.s1_title", body: "ds.page_services.s1_body",
          bullets: ["ds.page_services.s1_b1","ds.page_services.s1_b2","ds.page_services.s1_b3","ds.page_services.s1_b4"] },
        { title: "ds.page_services.s2_title", body: "ds.page_services.s2_body",
          bullets: ["ds.page_services.s2_b1","ds.page_services.s2_b2","ds.page_services.s2_b3","ds.page_services.s2_b4"] },
        { title: "ds.page_services.s3_title", body: "ds.page_services.s3_body",
          bullets: ["ds.page_services.s3_b1","ds.page_services.s3_b2","ds.page_services.s3_b3"] },
        { title: "ds.page_services.s4_title", body: "ds.page_services.s4_body" },
      ]} />
  );
}
